import { api } from "@/api"

import type { CreateUpdateProductFormOutput } from "@/composables/forms/useCreateUpdateProductForm"

import { queryClient } from "@/queryClient"

export const updateProduct = async (
  productId: string,
  params: CreateUpdateProductFormOutput
): Promise<undefined> => {
  await api.put<unknown>(
    `/products/products/${productId}`,
    {
      body: params,
    }
  )
  queryClient.invalidateQueries({
    queryKey: [BASE_PRODUCTS_QUERY_KEY],
  })
  return
}
